import { AUCTION_TYPES } from '../../common/auctionScrapeTypes'
import { PROPERTY_TYPES } from '../../common/drmTypes'
import { PROPERTY_TAB_KEYS } from '../../common/propertyDetailTypes'

export const defaultTabParam = 'tab'
export const defaultViewParam = 'view'
export const tabQuery = (tabKey?: string | null, tabParam = defaultTabParam) =>
  `${tabKey ? `?${tabParam}=${tabKey}` : ''}`

export const tabPath = (
  path: string,
  tabKey?: string,
  tabParam = defaultTabParam
) => `${path}${tabKey ? `?${tabParam}=${tabKey}` : ''}`

export const viewPath = (
  path: string,
  viewKey?: string,
  viewParam = defaultViewParam
) => `${path}${viewKey ? `?${viewParam}=${viewKey}` : ''}`

export const homePath = () => `/`
export const requestPath = (path?: string) => `/api/${path || ''}`

export const requestGeolocationApiPath = (ip?: string) => `/api/ipGeolocation/${ip || ''}`

export const requestRisyPath = () => `/api/risy/area`
export const requestAresPath = () => `/api/ares/`

export const requestRzpPath = () => `/api/rzp/`
export const requestRzpSubjectsPath = () => `/api/rzp/address`

export const requestDrmSubjectsPath = () => `/api/drmSubjects/`
export const requestSubjectPath = () => `/api/subject/`

export const requestLvPath = () => `/api/lv/`
export const requestLvGeometryPath = () => `/api/lvGeometry/`

export const requestProceedingDetailPath = () => `/api/proceeding/detail/`

export const requestPropertyRuianPath = (
  propertyType: PROPERTY_TYPES,
  token: string,
  propertyId: string
) => `/api/property/ruian/${propertyType}/${token}/${propertyId}/`

export const requestPropertyDrmPath = (
  propertyType: PROPERTY_TYPES,
  token: string,
  propertyId: string
) => `/api/property/drm/${propertyType}/${token}/${propertyId}/`

export const requestPropertyTimelinePath = (
  propertyType: PROPERTY_TYPES,
  token: string,
  propertyId: string
) => `/api/property/timeline/${propertyType}/${token}/${propertyId}/`

export const requestPropertyPolygonPath = (
  propertyType: PROPERTY_TYPES,
  token: string,
  propertyId: string
) => `/api/property/polygon/${propertyType}/${token}/${propertyId}/`

export const requestPropertyCrmDrmPath = (
  propertyType: PROPERTY_TYPES,
  tenantId: string,
  propertyId: string
) => `/api/property/crmDrm/${propertyType}/${tenantId}/${propertyId}/`

export const requestPropertyCrmTimelinePath = (
  propertyType: PROPERTY_TYPES,
  tenantId: string,
  propertyId: string
) => `/api/property/crmTimeline/${propertyType}/${tenantId}/${propertyId}/`

export const requestPropertyPricePath = (
  propertyType: PROPERTY_TYPES,
  token: string,
  propertyId: string
) => `/api/property/price/${propertyType}/${token}/${propertyId}`

export const requestAddressPath = () => `/api/address/`

export const requestGetParcelaIdPath = () => `/api/getPropertyId/parcela/`

export const requestCeePath = () => `/api/cee/`
export const requestCeeSubjectPath = () => `/api/cee/subject/`

export const requestCuzkPath = () => `/api/cuzk/`
export const requestNajdiOsPath = () => `/api/cuzk/najdiOs/`
export const requestnajdiListinuRizeniPath = () => `/api/cuzk/proceeding/document/`

export const cuzkWsdpPath = () => `/dalkovy-pristup`

export const cuzkMonitorRcPath = () => `/dalkovy-pristup/hlidac-subjektu-CUZK`
export const cuzkMonitorRcCreatePath = () => `/dalkovy-pristup/hlidac-subjektu-CUZK/pridat-novy`

export const cuzkDocumentCollectionPath = () => `/dalkovy-pristup/sbirka-listin`
export const cuzkDocumentCollectionFetchPath = (proceeding: string, id: string) => `/dalkovy-pristup/sbirka-listin/${proceeding}/${id}`

export const cuzkEpoPath = () => `/dalkovy-pristup/evidence-prav-pro-osobu`
export const cuzkEpoDetailPath = (id?: string) => `/dalkovy-pristup/evidence-prav-pro-osobu${id ? `/${id}` : ''}`

export const cuzkLvPath = () => `/dalkovy-pristup/list-vlastnictvi`
export const cuzkLvDownloadPath = (katuze: string, lv: string) => `/dalkovy-pristup/list-vlastnictvi/${katuze}/${lv}`
export const cuzkLvDetailPath = (id?: string) => `/dalkovy-pristup/list-vlastnictvi${id ? `/${id}` : ''}`

export const overwievPath = () => `/prehledy`

export const propertyNotePath = () => `/prehledy/poznamky`
export const labelPath = () => `/prehledy/stitky`
export const labelDetailPath = (id?: string) => `/prehledy/stitky/detail${id ? `/${id}` : ''}`

export const propertyPath = () => `/nemovitosti`
export const propertyDetailPath = (
  propertyType: PROPERTY_TYPES,
  id?: string,
  tab?: PROPERTY_TAB_KEYS
) => `/nemovitosti/${propertyType}${id ? `/${id}` : ''}/${tabQuery(tab)}`

export const lvPath = () => `/vyhledavani/list-vlastnictvi`
export const lvDetailPath = (katuze: string | number, lv: string | number) => `/vyhledavani/list-vlastnictvi/${katuze}/${lv}`

export const searchPath = () => `/vyhledavani`

export const dataBoxPath = () => `/vyhledavani/datova-schranka`
export const dataBoxDetailPath = (urlQuery?: string) => `/vyhledavani/datova-schranka${urlQuery ? `/${urlQuery}` : ''}`

export const proceedingPath = () => `/vyhledavani/rizeni`
export const proceedingDetailPath = (urlQuery?: string) => `/vyhledavani/rizeni${urlQuery ? `/${urlQuery}` : ''}`

export const addressPath = () => `/vyhledavani/adresa`
export const addressDetailPath = (urlQuery?: string | number) => `/vyhledavani/adresa${urlQuery ? `/${urlQuery}` : ''}`

/**
 * @param urlParams - string (name=''&address='')
 **/
export const subjectPath = (urlParams?: string) => `/vyhledavani/subjekt${urlParams ? `/?${urlParams}` : ''}`
export const subjectDetailPath = (id: string | number) => `/vyhledavani/subjekt${id ? `/${id}` : ''}`
/**
 * @deprecated redirect to subjectPath
**/
export const subjectsPath = () => `/vyhledavani/subjekty`

export const areaPath = () => `/vyhledavani/parcela`

export const marketplacePath = () => `/marketplace`
export const marketplaceStatisticsPath = () => `/marketplaceStatistiky`

export const cadastreMapPath = () => `/katastralni-mapy`
export const propertyListPath = () => `/seznam-nemovitosti`
export const propertyListDetailPath = (id?: string) => `/seznam-nemovitosti/detail${id ? `/${id}` : ''}`

export const priceEstimatePath = () => `/cenovy-odhad`

export const buybackPath = () => `/kalkulace-nabidek`
export const loanCalculatorPath = () => `/uverova-kalkulacka`

export const statisticsPath = () => `/statistikyVyuziti`

export const ceePath = () => `/CEE`
export const ceeMonitorPath = () => `/CEE/hlidac`
export const ceeMonitorCreatePath = () => `/CEE/hlidac/pridat-novy`
export const ceeCheckPath = () => `/CEE/vyhledavani`
export const ceeCheckCreatePath = () => `/CEE/vyhledavani/vyhledat-novy`

export const cadastrePostPath = () => `/katastralni-posta`
export const cadastrePostSentPath = () => `/katastralni-posta/prehled`
export const cadastrePostRecipientsPath = (id?: string) => `/katastralni-posta/seznam-adresatu${id ? `/${id}` : ''}`
export const cadastrePostLetterPath = (id?: string) => `/katastralni-posta/tvorba-dopisu${id ? `/${id}` : ''}`

export const postServicePath = () => `/hromadna-posta`
export const postServiceSentPath = () => `/hromadna-posta/prehled`
export const postServiceCreatePath = () => `/hromadna-posta/rozeslat`
export const postServiceTemplatesPath = () => `/hromadna-posta/sablony-dopisu`
export const postServiceRecipientListPath = () => `/hromadna-posta/adresati`

export const postServiceSentListPath = (id: string) => `/hromadna-posta/adresati/prehled/${id}`
// because Bartak
export const postServiceRecipientPath = (id?: string) => `/hromadna-posta/seznam-adresatu${id ? `/${id}` : ''}`
export const postServiceLetterPath = (
  recipientListId?: string,
  templateId?: string
) =>
  `/hromadna-posta/tvorba-dopisu${
    recipientListId ? `/${recipientListId}` : ''
  }${templateId ? `/sablona/${templateId}` : '/sablona'}`

export const foreclosureMapPath = () => `/monitoring/mapa/exekuce`
export const insolvencyMapPath = () => `/monitoring/mapa/insolvence`
export const auctionMapPath = () => `/monitoring/mapa/drazby`

export const monitoringPath = () => `/monitoring`

export const auctionMonitoringPath = (tab?: AUCTION_TYPES) => `/monitoring/drazby/${tabQuery(tab)}`
export const foreclosureMonitoringPath = (tab?: PROPERTY_TYPES) => `/monitoring/exekuce/${tabQuery(tab)}`
export const insolvencyMonitoringPath = (tab?: PROPERTY_TYPES) => `/monitoring/insolvence/${tabQuery(tab)}`

export const watchdogPath = () => `/monitoring/nemovitosti`
export const watchdogChannelPath = () => `/monitoring/nemovitosti/kanaly`
export const watchdogPropertyPath = (channelId?: string) => `/monitoring/nemovitosti/prehled${channelId ? `/${channelId}` : ''}`
export const heritageMonitoringPath = () => `/monitoring/dedictvi`

/**
 * @alias backward compatibility for old links
 * @deprecated use {@link propertyDetailPath} instead
*/
export const priceEstimateDetailPath = (type: string, id?: string) => `/cenovy-odhad/${type}/${id ? `${id}` : ''}`

export interface Path {
  name: string
  title?: string
  path: string
  disabled?: boolean
  guid?: boolean
}
